import { initEmblaSlider } from './lib/embla';
import { SmoothScrollNav } from './lib/navigation';
import { initPricingWithEmbla } from './lib/price';

document.addEventListener('DOMContentLoaded', () => {
  initEmblaSlider({
    target: '#js-embla-benefits',
    options: {
      loop: false,
      active: false,
      breakpoints: {
        '(max-width: 1024px)': {
          active: true,
        },
      },
    },
  });

  initEmblaSlider({
    target: '#js-embla-apps',
    options: {
      loop: false,
      active: false,
      breakpoints: {
        '(max-width: 768px)': {
          active: true,
        },
      },
    },
  });

  initEmblaSlider({
    target: '#js-embla-comments',
    options: {
      loop: false,
      align: 'start',
    },
  });

  initEmblaSlider({
    target: '#js-embla-compare',
    options: {
      loop: false,
      active: false,
      breakpoints: {
        '(max-width: 1024px)': {
          active: true,
        },
      },
    },
  });

  initPricingWithEmbla();

  initEmblaSlider({
    target: '.js-embla-price',
    options: {
      loop: false,
      active: false,
      startIndex: 1,
      breakpoints: {
        '(max-width: 1024px)': {
          active: true,
        },
      },
    },
  });

  new SmoothScrollNav();
});
